import { inject, injectable } from "inversify";

export const LEGISLATION = {
	CZ: "cz",
	RO: "ro",
	MT: "mt",
	SK: "sk",
};

import IRegulation from "./IRegulation";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import FetchAjax from "../connect/FetchAjax";
import IInfoPages from "../engine/IInfoPages";
import IGame from "../game/IGame";
import Messages from "../Messages";
import Settings from "../settings/Settings";
import IStatesManager from "../states/IStatesManager";
import SystemConfig, { CONFIG_PARAMS } from "../system/SystemConfig";
import SystemTime from "../system/SystemTime";

import events from "../events/EventsObservable";
import { ACTION_EVENTS } from "../ui/UserAction";
import { BASE_ELEMENT_IDS } from "../ui/BaseDOM";

@injectable()
export default class Regulation implements IRegulation {
	/**
	 * _switch - when to show the icon,
	 * values: "all"  - show everywhere
	 *         "none" - do not show icon
	 *         "info" - show only when infopages are open
	 * default value "all", set in init()
	 */
	protected _switch: string;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) protected _config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.SystemTime) protected _systemTime: SystemTime,
		@inject(SERVICE_IDENTIFIER.Game) protected _game: IGame,
		@inject(SERVICE_IDENTIFIER.SystemMessages) protected _messages: Messages,
		@inject(SERVICE_IDENTIFIER.FetchAjax) protected _ajax: FetchAjax,
		@inject(SERVICE_IDENTIFIER.StatesManager)
		protected _statesManager: IStatesManager,
		@inject(SERVICE_IDENTIFIER.InfoPages) protected _infoPages: IInfoPages,
		@inject(SERVICE_IDENTIFIER.Settings) protected _settings: Settings
	) {}
	init() {
		if (this._config.get(CONFIG_PARAMS.RESPONSIBLE_GAMING)) {
			this._switch = this._config.get(CONFIG_PARAMS.RESPONSIBLE_GAMING);
		} else {
			this._switch = "none"; // default value
		}
		events.subscribe(
			ACTION_EVENTS.ACTION_RESPONSIBLE_GAMING,
			(eventName, data) => this.onClickIcon(data)
		);
	}

	load(): Promise<any> {
		return Promise.resolve();
	}

	start() {
		switch (this._switch) {
			case "all":
				this.show();
				break;
			case "none":
			case "info":
			default:
				this.hide();
				break;
		}
	}
	hide() {
		$("#" + BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING).hide();
	}

	show() {
		$("#" + BASE_ELEMENT_IDS.BUTTON_RESPONSIBLE_GAMING).show();
	}
	onClickIcon(data) {
		const dynamicURL = this._settings.getDynamicUrls()?.responsible_gaming_url;
		if (dynamicURL) {
			return window.open(dynamicURL, "_blank");
		}
	}
}
